<div class="card-container" (click)="handleClick()" tabindex="0">
  <div class="patient-info">
    <div class="property" *ngIf="this.exam?.patient?.name !== undefined">
      <span class="property-title">{{ exam?.patient?.name }}</span>
      <div *ngIf="nonReads > 0" class="non-reads">
        {{ nonReads }}
      </div>
    </div>
    <!--<div class="property" *ngIf="this.exam?.patient === null || this.exam?.patient === undefined">
            {{ labels.EXTERNAL_PATIENT_DATA }}
        </div>-->
    <p
      class="property property-ellipsis"
      *ngIf="this.exam?.code !== undefined && this.exam?.code !== ''"
    >
      <span class="property-title">{{ labels.CODE }}</span
      >{{ exam?.code }}
    </p>
  </div>
  <div class="bottom-info">
    <div class="release-info"></div>
    <div class="status-panel">
      <div class="status-box urgent" *ngIf="urgent">{{ labels.URGENT }}</div>
      <div
        class="status-box not-started"
        *ngIf="status === labels.NOT_STARTED.key"
      >
        {{ labels.NOT_STARTED.label }}
      </div>
      <div class="status-box started" *ngIf="status === labels.STARTED.key">
        {{ labels.STARTED.label }}
      </div>
      <div class="status-box finished" *ngIf="status === labels.FINISHED.key">
        {{ labels.FINISHED.label }}
      </div>
    </div>
  </div>
</div>
